import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import TTLProxy from "./TTLAsyncProxy";
import PropTypes from "prop-types";

export default class ProtectedRoute extends Route {

    redirectTo(path){
        return (<Redirect to={{pathname: path}}/>);
    }

    render() {

        const proxy = TTLProxy.getInstance();
        const redirectPath =  this.props.redirectPath || "/login";

        if (!this.props.allowAnonymous && proxy.isAuthenticated()) {
            return this.redirectTo('/dashboard');
        }

        //  params restrictions
        if(this.props.matchParams) {

            //
            let params = this.props.computedMatch.params;
            let match = this.props.matchParams;

            for(let item in match) {

                let val = match[item];
                if(Array.isArray(val)){

                    if(val.indexOf( params[item] ) < 0){
                        return this.redirectTo(redirectPath );
                    }
                }
                else if(typeof val === 'string') {
                    if(val != params[item])
                        return this.redirectTo(redirectPath);
                }
            }

        }

        return (
            <Route exact path={this.props.path} name={this.props.name} component={this.props.component} history={this.props.history}/>
        );
    }
}

ProtectedRoute.propTypes ={
    path: PropTypes.string,
    name: PropTypes.string,
    redirectPath: PropTypes.string,
    component: PropTypes.func,
    history: PropTypes.object,
    matchParams: PropTypes.array,
    allowAnonymous: PropTypes.bool
};


// WEBPACK FOOTER //
// ./src/common/ProtectedRoute.js